import { DEFAULT_RRULE_DAYS_STATE } from "@/consts";
import { toUnix } from "@/stories/utils/dates";
import type { RruleOptions } from "@/types";
import { Frequency, RRule, RRuleSet } from "rrule";

const FREQ_MAP: Record<Frequency, number> = {
  [Frequency.DAILY]: 1,
  [Frequency.WEEKLY]: 7,
  [Frequency.MONTHLY]: 30,
  [Frequency.YEARLY]: 365,
  [Frequency.HOURLY]: 0,
  [Frequency.MINUTELY]: 0,
  [Frequency.SECONDLY]: 0,
};

export default (rule: RRule | RRuleSet): RruleOptions => {
  const days = { ...DEFAULT_RRULE_DAYS_STATE };

  (rule.options.byweekday || []).forEach((key) => {
    days[key] = true;
  });

  const options: RruleOptions = {
    cadence: FREQ_MAP[rule.options.freq],
    occurence: rule.options.interval || 1,
    days,
  };

  if (rule.options.dtstart) {
    options.startDate = toUnix(rule.options.dtstart);
  }

  if (rule.options.until) {
    options.endingDate = toUnix(rule.options.until);
    options.endingType = "finish_on";
  }

  if (rule.options.count) {
    options.repeatAmount = rule.options.count;
    options.endingType = "finish_after";
  }

  return options;
};
